import { motion } from 'framer-motion'
import { Check } from 'lucide-react'
import { services } from '../data.ts'
import SectionHeading from './SectionHeading.tsx'
import React from 'react'

export default function Services() {
  return (
    <section id="services" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="What we do"
          title={<>Everything you need to <span className="text-gradient">launch and grow</span> online</>}
          subtitle="From a simple business site to a full dynamic web app, we cover the entire journey — design, development, and ongoing care."
        />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-all duration-300 hover:border-brand-500/40 hover:bg-white/[0.06] sm:p-7"
            >
              <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-brand-500/10 blur-2xl transition-opacity duration-300 group-hover:opacity-100 opacity-0" />
              <div className="relative">
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-gradient-to-br from-brand-500/20 to-brand-700/10 text-brand-300 ring-1 ring-brand-500/20 transition-transform duration-300 group-hover:scale-110">
                  <s.icon size={22} />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-white">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                <ul className="mt-5 grid grid-cols-2 gap-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-1.5 text-xs text-slate-300">
                      <Check size={13} className="shrink-0 text-brand-400" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}
